var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.$vuetify.breakpoint.smAndUp ? 'px-6' : ''},[_c('v-card',{staticClass:"my-2",attrs:{"outlined":"","max-height":"100%"}},[_c('ClientBreadcrumb',{attrs:{"current-page":"Serviços"}}),_c('ServicePurchase',{attrs:{"outlined":false,"hasAction":"","loading":_vm.loading},on:{"action":_vm.buyServices}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }